var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack394({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1.5,
    y: 1.5,
    width: 13,
    height: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4,11.16V6.74H2.61V6.15H5.87v.59H4.51v4.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.6,11.16,6,6.15h.59L7.66,9.79c.09.28.16.55.22.82.06-.28.14-.55.22-.82L9.21,6.15h.55l-1.6,5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.25,11.16v-5h1.54a2.64,2.64,0,0,1,.81.09,1.11,1.11,0,0,1,.57.48,1.7,1.7,0,0,1,.21.87A1.74,1.74,0,0,1,13,8.69a1.46,1.46,0,0,1-1.2.43H10.79v2Zm.54-2.63h1.06a1,1,0,0,0,.74-.23.93.93,0,0,0,.23-.68,1.13,1.13,0,0,0-.11-.51.66.66,0,0,0-.28-.29,1.39,1.39,0,0,0-.59-.08H10.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack394);
export default __webpack_public_path__ + "static/media/Symbol_pack_394.44279645e5313e812d44a50bcc429d65.svg";
export { ForwardRef as ReactComponent };